import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';

const app = createApp(App);

app.use(router);
app.use(store);
app.use(ElementPlus);

// 全局错误处理，避免错误弹出遮挡
app.config.errorHandler = (err, vm, info) => {
    console.error('捕获到全局错误：', err); // 可根据需要记录日志
};

// 防止控制台警告导致遮罩页
app.config.warnHandler = function (msg, vm, trace) {
    console.warn(`Vue 警告: ${msg}\n${trace}`);
};


app.mount('#app');
